import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { browserHistory } from 'common/utils/browserHistory';
import DateOfBirth from 'common/display/DateOfBirth';
import { validateReduxForm } from 'common/form';
import {
  Button,
} from '@unite-us/ui';
import _ from 'lodash';
import Header from './Header';
import ContactDetailReviewDemographic from './ContactDetailReviewDemographic';
import ContactDataAsDisplay from './ContactDataAsDisplay';
import '../stylesheets/contactStepper.scss';

class ContactDetailReviewFromAssistanceRequest extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.restartAssistanceRequestProcess = this.restartAssistanceRequestProcess.bind(this);
  }

  onSubmit() {
    return this.props.onComplete();
  }

  restartAssistanceRequestProcess() {
    const { assistanceRequestId } = this.props;
    browserHistory.push(`/assistance-requests/${assistanceRequestId}`);
  }

  render() {
    const {
      handleSubmit,
      submitting,
      contact = {},
      fields,
      header,
      mainHeader,
      subHeader,
      enums,
    } = this.props;

    return (
      <form
        className="contact-details-review"
        onSubmit={handleSubmit(this.onSubmit)}
      >
        <Header
          header={header}
          mainHeader={mainHeader}
          subHeader={subHeader}
        />

        <div className="confirmed-details">
          <div className="confirmed-details__wrapper">
            <div className="confirmed-details__name confirmed-details__row">
              <span className="strong">Name: </span>
              <span> {contact.full_name}</span>
            </div>

            <div className="confirmed-details__dob confirmed-details__row">
              <span className="strong">Date of Birth</span>
              <div>
                <DateOfBirth date={contact.date_of_birth} />
              </div>
            </div>

            <div className="confirmed-details__contact-data confirmed-details__row">
              <ContactDataAsDisplay fields={fields} />
            </div>

            <ContactDetailReviewDemographic enums={enums} fields={fields} />
          </div>
        </div>

        <footer className="referral-footer">
          <Button
            id="go-back-btn"
            onClick={this.restartAssistanceRequestProcess}
            label="Go Back"
            style={{ marginRight: '10px' }}
          />
          <Button
            id="next-btn"
            onClick={handleSubmit(this.onSubmit)}
            label="Next"
            disabled={submitting}
            style={{ float: 'right' }}
            primary
          />
        </footer>
      </form>
    );
  }
}

ContactDetailReviewFromAssistanceRequest.propTypes = {
  contact: PropTypes.object.isRequired,
  enums: PropTypes.object,
  fields: PropTypes.object,
  handleSubmit: PropTypes.func,
  header: PropTypes.string.isRequired,
  mainHeader: PropTypes.string,
  onComplete: PropTypes.func.isRequired,
  subHeader: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  assistanceRequestId: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const { selectedContact, session } = state;
  const groupId = _.wget(session, 'groupId', '');
  const allContacts = [
    ...state.searchedContacts,
    ..._.wget(state, 'contacts.contacts', []),
  ];
  const contact = _.find(allContacts, { id: selectedContact }) || {};

  const primaryEmail = _.get(contact, 'email_addresses', [])
    .find((email) => email.is_primary) || {};

  const primaryPhone = _.get(contact, 'phone_numbers', [])
    .find((phone) => phone.is_primary) || {};

  return {
    groupId,
    selectedContact,
    contact,
    enums: _.get(session, 'enums'),
    initialValues: {
      email: primaryEmail.email_address,
      phone: primaryPhone.phone_number,
      phone_type: primaryPhone.phone_type,
      gender: contact.gender,
      marital_status: contact.marital_status,
      race: contact.race,
      ethnicity: contact.ethnicity,
    },
  };
}

export const fields = [
  'email',
  'ethnicity',
  'gender',
  'phone',
  'phone_type',
  'marital_status',
  'race',
];
export default validateReduxForm(
  {
    form: 'contact',
    fields,
    destroyOnUnmount: true,
  },
  mapStateToProps,
  null,
)(ContactDetailReviewFromAssistanceRequest);
